import { ChangeDetectorRef,Component } from '@angular/core';
import { Product } from '../../interfaces/product.interface'; 
import { ProductcodeService } from "../../services/productcode";
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-edit-product',
  imports: [ReactiveFormsModule],
  templateUrl: './edit-product.html',
  styleUrl: './edit-product.css',
})
export class EditProductComponent {
  products: Product[] = [];
  myForm: FormGroup;
  selectedProduct: Product | null = null;

    constructor(private productcodeService: ProductcodeService, 
                private cdr: ChangeDetectorRef,
                private router: Router,
                private fb: FormBuilder) 
                {
                  this.myForm = this.fb.group({
                    id: new FormControl(''),
                    description: new FormControl('',[Validators.required,Validators.maxLength(100)]),
                    description2: new FormControl('',[Validators.required,Validators.maxLength(100)]),
                    productcode: new FormControl('',[Validators.maxLength(25)]),
                    uom: new FormControl('',[Validators.maxLength(5)]) 
                  });
                }
   async ngOnInit(): Promise<void>
  {

      this.selectedProduct = this.productcodeService.selectedProduct;

      this.myForm.get('id')?.setValue(this.productcodeService.selectedProduct.id);
      this.myForm.get('description')?.setValue(this.productcodeService.selectedProduct.description);
      this.myForm.get('description2')?.setValue(this.productcodeService.selectedProduct.description2);
      this.myForm.get('productcode')?.setValue(this.productcodeService.selectedProduct.productcode);
      this.myForm.get('uom')?.setValue(this.productcodeService.selectedProduct.uom);
       
  }

  get id() { return this.myForm.get('id'); }
  get description() { return this.myForm.get('description'); }
  get description2() { return this.myForm.get('description2'); }
  get productcode() { return this.myForm.get('productcode'); }
  get uom() { return this.myForm.get('uom'); }

  async updateProduct(): Promise<void>
  {
    var id = this.myForm.value.id != null ? this.myForm.value.id.trim() : "";
    var description = this.myForm.value.description != null ? this.myForm.value.description.trim() : "";
    var description2 = this.myForm.value.description2 != null ? this.myForm.value.description2.trim() : "";
    var productcode = this.myForm.value.productcode != null ? this.myForm.value.productcode.trim() : "";
    var uom = this.myForm.value.uom != null ? this.myForm.value.uom.trim() : "";

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

 try
        {
          await this.productcodeService.updateProduct(id, description, description2, productcode, uom);
          this.cdr.detectChanges();
          this.router.navigateByUrl('product'); 
        } catch (error) {
          console.error('update product error',error);
        }

  }   

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('product');
  }  

}
